import { Stack } from '@ui-components/neo.tax';
import { useEffect } from 'react';

import {
  AnalysisType,
  OnboardingFlowStage,
  useOnboardingFlowStage,
  useUnfinishedSyncEventInPeriodByAnalysisType,
  AnalysisInfo,
  GetStartedHero,
  OnboardingFlowProcessingHero,
} from '@neo.tax/shared';
import { useSredContext } from '@neo.tax/sred/context';

import { SredProjectsLayout } from '../sred-projects-layout';

export const SredProjectsLoader = (): React.ReactElement => {
  const { stage, startPolling, stopPolling } = useOnboardingFlowStage();
  const { fiscalYearId, period, periodName } = useSredContext();
  const { period: unfinishedSyncEventsPeriod } = useUnfinishedSyncEventInPeriodByAnalysisType({
    fiscalYearId,
    periodName,
    analysisType: AnalysisType.CaSred,
  });
  useEffect(() => {
    // Start polling after the user submits their data and the stage changes to DATA_PROCESSING_IN_PROGRESS
    if (stage === OnboardingFlowStage.DATA_PROCESSING_IN_PROGRESS) {
      startPolling(5000);
    } else {
      stopPolling();
    }
  }, [stage, startPolling, stopPolling]);

  if (
    stage === OnboardingFlowStage.DATA_PROCESSING_COMPLETED ||
    (stage === OnboardingFlowStage.DATA_PROCESSING_IN_PROGRESS && !unfinishedSyncEventsPeriod)
  ) {
    return <SredProjectsLayout />;
  }

  return (
    <Stack fullHeight direction="column" paddingY={8} paddingX={6} gap={6}>
      {stage === OnboardingFlowStage.INITIAL ? (
        <GetStartedHero
          analysisType={AnalysisType.CaSred}
          fiscalYearId={fiscalYearId}
          periodName={periodName}
          period={period}
        />
      ) : (
        <OnboardingFlowProcessingHero />
      )}
      <AnalysisInfo />
    </Stack>
  );
};
